// @ts-strict-ignore
import { createReducer, on } from "@ngrx/store";
import { ESimActions } from "./esim.actions.types";

export interface ESimState {
  editingProfileId: number;
  wizardLoadedSectionKey: string;
  wizardLoadedSubSectionKey: string;
  overrideNavigationControls: boolean;
  overrideNavigationBackTriggered: boolean;
  overrideNavigationNextTriggered: boolean;
  newProfileType: string;
  newSchemaSelectionOption: any;
  expertUnsavedChanges: boolean;
}

export const defaultState: ESimState = {
  editingProfileId: null,
  wizardLoadedSectionKey: "",
  wizardLoadedSubSectionKey: "",
  overrideNavigationControls: false,
  overrideNavigationBackTriggered: false,
  overrideNavigationNextTriggered: false,
  newProfileType: "EWiz",
  newSchemaSelectionOption: null,
  expertUnsavedChanges: false
};

export const ESimReducer = createReducer(
  defaultState,
  on(ESimActions.SetEditingProfileId, (state, action) => {
    return {
      ...state,
      editingProfileId: action.profileId
    };
  }),
  on(ESimActions.SetWizardNavState, (state, action) => {
    return {
      ...state,
      wizardLoadedSectionKey: action.wizardLoadedSectionKey,
      wizardLoadedSubSectionKey: action.wizardLoadedSubSectionKey
    };
  }),
  on(ESimActions.SetOverrideNavigationControls, (state, action) => {
    return {
      ...state,
      overrideNavigationControls: action.overrideNavigationControls
    };
  }),
  on(ESimActions.SetOverrideNavigationBackTriggered, (state, action) => {
    return {
      ...state,
      overrideNavigationBackTriggered: action.overrideNavigationBackTriggered
    };
  }),
  on(ESimActions.SetOverrideNavigationNextTriggered, (state, action) => {
    return {
      ...state,
      overrideNavigationNextTriggered: action.overrideNavigationNextTriggered
    };
  }),
  on(ESimActions.SetNewExpertProfileOptions, (state, action) => {
    return {
      ...state,
      newProfileType: action.profileType,
      newSchemaSelectionOption: action.schemaSelectionOption
    };
  }),
  on(ESimActions.SetExpertUnsavedChanges, (state, action) => {
    return {
      ...state,
      expertUnsavedChanges: action.unsavedChanges
    };
  })
);
